import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="js-select2"
export default class extends Controller {
  static targets = ["fields", "alwaysVisibleOption"]
  static values = { dispatchChange: { type: Boolean, default: true } }

  connect() {
    this.initializeSelect2()
  }

  initializeSelect2() {
    const controller = this
    const alwaysVisibleTexts = this.alwaysVisibleOptionTargets.map(el => el.textContent)

    $(this.fieldsTargets).each(function(){
      const allowClear = $(this).data('allowclear') !== undefined ? $(this).data('allowclear') : true
      const config = {
        dropdownParent: $(this).parent(),
        dropdownAutoWidth: this.dataset.dropdownAutoWidth === 'true',
        width: "100%",
        theme: "bootstrap",
        allowClear,
        placeholder: $(this).data('placeholder') || (allowClear ? "" : undefined),
        minimumResultsForSearch: $(this).data('allowsearch') === false ? -1 : 0,
        templateResult: $(this).data('withhints') === true ? function(option) {
          if (!option.id || !option.element) return option.text
          const hint = option.element.dataset.hint
          return $('<span>' + option.text + '<small class="text-muted d-block">' + hint + '</small></span>')
        } : undefined,
        matcher: function (params, data) {
          const emptySearch = $.trim(params.term) === ''
          const isAlwaysVisible = alwaysVisibleTexts.includes(data.text)
          const matchSearch = params.term && data.text.toLowerCase().includes(params.term.toLowerCase())

          if (emptySearch || isAlwaysVisible || matchSearch) return data;

          return null;
        },
        insertTag: function (data, tag) {
          data.push({ id: tag.id, text: `+ Créer ${tag.text}` });
        },
      }
      $(this).select2(config)

      $(this).on("select2:select select2:unselect", function() {
        if (controller.dispatchChangeValue) {
          this.dispatchEvent(new Event("change", { bubbles: true }))
        }
      })
    })
  }
}
